import useModule from './useModule'

const capitalizeFirstLetter = (value: string): string => {
  if (!value) return ''

  return value.charAt(0).toUpperCase() + value.slice(1)
}

const useConfigTypeTitle = (isTitle: boolean = false): string => {
  const [isMonitor] = useModule()

  const configType = isMonitor
    ? 'monitor'
    : 'test'

  return isTitle
    ? capitalizeFirstLetter(configType)
    : configType
}

export default useConfigTypeTitle
